import { isPlatformBrowser } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { map, Observable } from 'rxjs';
import { Configuration } from '../../../app.constants';
import { BaseConfigurationViewModel } from '../viewModels/baseConfigurationViewModel';
import { AuthenticationService } from './authentication.service';
import { CachingService } from './caching.service';

@Injectable()
export class ConfigurationService {
  private actionUrl: string;
  private currentUrl: URL;
  isBrowser: boolean;
  cachingService: any;

  constructor(
    private configuration: Configuration,
    private authenticationService: AuthenticationService,
    private http: HttpClient,
    private caches: CachingService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    const href: string = isPlatformBrowser(this.platformId) ? window.location.href : 'n/a';
    this.currentUrl = new URL(href);
    this.actionUrl = this.currentUrl.origin + '/v1/';

    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  public GetBaseConfiguration(accountGUID: string): Observable<BaseConfigurationViewModel> {
    const bConfigRequest = new BaseConfigurationViewModel();
    bConfigRequest.accountGuid = accountGUID;

    const body = JSON.stringify(bConfigRequest);
    const url = this.configuration.buildEndpoint(`configuration/base/${accountGUID}`);

    const options = this.authenticationService.getHttpOptions();

    return this.http.post<BaseConfigurationViewModel>(url, body, options).pipe(
      map((data) => {
        if (data && data.accountId > 0) {
          this.caches.AddAccountConfiguration(data);
        }

        return data;
      })
    );
  };
}
